import React from 'react';
import { FooterView } from '../Components';
import './QualificationCertificate.css';
import { useNavigate } from 'react-router-dom';
import sportsCar from '../../assets/disclaimers_images/20230902_000016.jpg';
import angryLittleGirl from '../../assets/disclaimers_images/20230902_000037.png';
import sportsImg from '../../assets/disclaimers_images/20230902_000108.png';
import sportsOne from '../../assets/disclaimers_images//20230902_000122.png';
import angryGirl from '../../assets/disclaimers_images/20230902_000100.jpg';
import breakthroughPoint from '../../assets/disclaimers_images/20230903-180400.png';
import mainStream from '../../assets/disclaimers_images/20230902_000046.png';

const QualificationCertificate = () => {
  const navigate = useNavigate();
  const RecommendedNewsList = [
    {
      key: '9',
      url: sportsOne,
      title: '2023年将成为企业数字化转型的拐点',
      time: '2022-12-29',
      content:
        '极不平凡的2022年即将过去，包括疫情在内的各个因素冲撞下，当下的大环境已演变为充满不确定性。不过，尽管全球经济面临前所未有的风浪，但一个相对确定的趋势是，2023年将成为企业数字化转型的拐点。',
    },
    {
      key: '8',
      url: sportsImg,
      title: '中国银行业协会发布《中国保理产业发展报告（2021-2022）》',
      time: '2022-12-02',
      content:
        '近日，中国银行业协会发布了《中国保理产业发展报告（2021-2022）》（以下简称《报告》）。这是中国银行业协会连续第十年发布保理产业发展报告。《报告》由中国银行业协会成员单位中国银行牵头，国家开发银行、中国工商银行、中国农业银行、中国建设银行、交通银行、中国邮政储蓄银行、中信银行、中国光大银行、招商银行、上海浦东发展银行、中国民生银行、平安银行、北京银行、汇丰银行（中国）、网商银行等15家成员单位共同参与撰写。',
    },
    {
      key: '6',
      url: angryGirl,
      title: '《供应链数字化管理指南》等4项两化融合国家标准正式发布实施',
      time: '2022-10-25',
      content:
        '两化融合是指以信息化带动工业化、以工业化促进信息化，走新型工业化道路；利用信息技术作支撑，改造提升传统动能，培育新动能，追求可持续发展模式。推进两化融合是中央的一项长期性战略部署，也是新发展阶段制造业数字化、网络化、智能化发展的必由之路 。',
    },
  ];
  const specialColumnList = [
    {
      key: '2',
      url: breakthroughPoint,
      title: '供应链金融科技发展的挑战及趋势',
      time: '2022-7-20',
      content:
        '供应链金融在拓宽中小企业融资渠道、提高产业链竞争力等方面发挥了举足轻重的作用，对加快构建新发展格局和助力实现共同富裕的意义重大。供应链金融在取得近30年发展成绩的同时，也暴露出高度依赖核心企业、产融结合不紧、科技应用能力不足等问题。如何利用数字科技优化供应链金融服务效率，改善小微企业金融服务的制度和商业模式约束，是整个行业都在探索思考的重大现实问题。',
    },
    {
      key: '1',
      url: mainStream,
      title: '《中国金融》｜推进金融科技产业“三融合”',
      time: '2022-6-20',
      content:
        '国家“十四五”规划和2035年远景目标纲要明确提出，要构建实体经济、科技创新、现代金融、人力资源协同发展的现代产业体系。金融是实体经济的血脉，科技是第一生产力，产业是现代经济的根基，科学把握金融发展、科技创新、产业升级的客观规律，进一步加强金融、科技、产业融合互动，实现金融要素、科技资源和产业需求的有效对接，对增强国家自主创新能力、推动高质量发展具有重要意义。',
    },
    {
      key: '0',
      url: sportsCar,
      title: '挚云数科助力和信保理发行全国首单京津冀科技创新资产支持票据',
      time: '2023-05-20',
      content:
        '2022年3月31日，我司战略合作伙伴和信（天津）国际商业保理有限公司成功发行“和信（天津）国际商业保理有限公司2022年度畅达-天银京津冀科技创新第一期定向资产支持票据”。该项目是全国首单京津冀科技创新资产支持票据，获得天津市金融局及社会各界的广泛关注与认可，挚云数科作为和信保理的独家系统服务提供商，以稳定便利的系统，助力客户业务成长。',
    },
    {
      key: '10',
      url: angryLittleGirl,
      title: '挚云数科应邀参加天津财经大学2023年毕业生春季校园招聘会',
      time: '2023-03-10',
      content:
        '3月10日，天津财经大学举办2023毕业生春季校园大型招聘会，超过200家企业参加，挚云数科应邀也参加了此次大型活动。本年度公司招聘计划中包含前端工程师、后端工程师、运维工程师、解决方案业务助理、财务助理等多个岗位面向毕业生和实习生招聘，储备人才，此次双选会举办的非常成功!',
    },
  ];
  // 进入详情
  const handelToIndustryDetails = (item) => {
    // console.log(item.key,"item.key")
    localStorage.setItem('detailId', item.key);
    navigate('/details', { state: { id: item.key } });
  };
  return (
    <div className="QualificationCertificate">
      <div className="NewsInformationCntent">
        {/* <div className='NewsRanking'>
        <div className='RankingHeder'>
          <div className='RankingHederText'>新闻排行</div>
          <div className='RankingMore'>查看更多&gt;&gt;</div>
        </div>
        <div>
      <div className='RankingContent'>
          <div className='RankingContentList'>
            <div className='DevelopmentList'>
              {
                developmentList.map(item =>{
                  return (
                    <div className='DevelopmentListItem'>
                      <div className='DevelopmentSerialNumber' style={{ background: item.color }}>{item.num}</div>
                      <img className='DevelopmentListImg' src={item.url} />
                      <div className='DevelopmentContent'>
                        <div className='DevelopmentText'>
                          <div className='DevelopmentTextone'>{item.text}</div>
                          <div className='DevelopmentTime'>{item.time}</div>
                        </div>
                        <div className='DevelopmentTextContent'>{item.content}</div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
            <div className='PopularEvents'>
              <img className='PopularEventsImg' src={plicableUrl} />
              <div className='PopularEventsText'>今日热门事件</div>
              <div className='PopularEventsContent'>包图网汇集了各种流行趋势,视觉冲击力强的原创广告图片设计、电商淘宝、企业办公模板素材,由顶尖的设计师供稿,符合各个行业的商用需求,下载高品质正版素材就到包图网。包图网汇集了各种流行趋势,视觉冲击力强的原创广告图片设计、</div>
            </div>
          </div>
        </div>
      </div> */}
        <div className="RecommendedNews">
          <div className="RecommendeHeader">
            <div className="RecommendedText"></div>
            <div className="RecommendedNewsTitle">每日推荐新闻</div>
          </div>
          <div className="recommendList">
            {RecommendedNewsList.map((item, ind) => {
              return (
                <div
                  className="recommendListItem"
                  key={ind}
                  onClick={() => handelToIndustryDetails(item)}
                >
                  <img className="recommendListImg" src={item.url} alt="" />
                  <div className="recommendContent">
                    <div className="recommendHeader">
                      <div className="recommendTitle">{item.title}</div>
                      <div className="recommendTime">{item.time}</div>
                    </div>
                    <div className="recommendText">{item.content}</div>
                    {/* <div className='recommendFooter'>
                      <div className='recommendShareNum'><BranchesOutlined /> { item.shareNum } 人分享</div>
                      <div className='recommendLikeNum'><HeartFilled /> {item.likeNum} 点赞</div>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="specialColumn">
          <div className="specialColumnHeader">
            <div className="RecommendedText"></div>
            <div className="RecommendedNewsTitle">专栏</div>
          </div>
          <div className="specialColumnContent">
            {specialColumnList.map((item, ind) => {
              return (
                <div
                  className="specialColumnItem"
                  key={ind}
                  onClick={() => handelToIndustryDetails(item)}
                >
                  <img className="specialColumnImg" src={item.url} alt="" />
                  <div className="specialColumnRight">
                    <div className="ColumnItemtitle">{item.title}</div>
                    <div className="ColumnItemText">{item.content}</div>
                    <div className="ColumnItemTime">{item.time}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  );
};

export default QualificationCertificate;
